import React, { ReactNode } from 'react';

type BlockInteractionsContentType = {
  id: string;
  children: ReactNode;
};

export function BlockInteractionsContent({ id, children }: BlockInteractionsContentType) {
  return (
    <div className="block-interactions__content" id={`block-content-${id}`}>
      {children}
    </div>
  );
}
